var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMeetingLinkVideo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "video-camera-fill",
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.787,
    height: 16.332,
    viewBox: "0 0 25.787 16.332",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_13754",
    "data-name": "Path 13754",
    d: "M26.051,56.3V66.613a1.721,1.721,0,0,1-1.719,1.719H12.3a4.3,4.3,0,0,1-4.3-4.3V53.719A1.721,1.721,0,0,1,9.719,52H21.753A4.3,4.3,0,0,1,26.051,56.3Zm7.308-2.033a.86.86,0,0,0-.858,0l-4.3,2.456a.86.86,0,0,0-.433.746v5.4a.86.86,0,0,0,.433.746l4.3,2.456a.86.86,0,0,0,1.286-.746V55.009a.859.859,0,0,0-.428-.743Z",
    transform: "translate(-8 -52)",
    fill: "rgba(255,255,255,0.64)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeetingLinkVideo);
export default __webpack_public_path__ + "static/media/meeting-link-video.1870ec8839927ac93e348e598019dbe4.svg";
export { ForwardRef as ReactComponent };